import { Button } from '@kanda-libs/ks-design-library';

import { BASE_PROPS } from '../SaveAsDraftButton-constants';

const ViewComponent = ({ ...props }) => (
  <Button.Text {...BASE_PROPS} size={24} className="mr-2" {...props} />
);

ViewComponent.displayName = 'CreateJob-SaveDraftButton-Mobile-view';

export default ViewComponent;
